import { AsxSortItems, AsxSortValues } from './AsxAnnouncements.types';

export const YOURIR_BASE_ENDPOINT = 'https://yourir.info';

export const asxValidSortParams: AsxSortValues[] = ['most-recent', 'oldest'];

export const asxSortItemsMap = new Map<AsxSortValues, AsxSortItems>([
  [
    'most-recent',
    {
      label: 'Most recent',
      value: 'desc',
    },
  ],
  [
    'oldest',
    {
      label: 'Oldest',
      value: 'asc',
    },
  ],
]);

export const ASX_PAGE_LIMIT = 12;

export const ASX_ANNOUNCEMENTS_BASE_PATH = '/investors/announcements';

export const ASX_PAGE_NUMBER_BUFFER = 1.05;
